import _ from 'lodash';
import { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useAppFormatNumber = () => {
	const { i18n } = useTranslation();

	const formatPercent = useCallback(
		(value: number, round = 2) => {
			return _.round(value * 100, round).toLocaleString(i18n.language, {
				minimumFractionDigits: round,
				maximumFractionDigits: round,
			});
		},
		[i18n.language],
	);

	const formatAmount = useCallback(
		(value: number, round = 2, ignoreMaxDigits = false) => {
			return _.round(value, ignoreMaxDigits ? 9 : round).toLocaleString(i18n.language, {
				minimumFractionDigits: round,
				maximumFractionDigits: ignoreMaxDigits ? 9 : round,
			});
		},
		[i18n.language],
	);

	return useMemo(
		() => ({
			formatPercent,
			formatAmount,
		}),
		[formatAmount, formatPercent],
	);
};

export default useAppFormatNumber;
